import { find } from "rxjs";
import { OpcionMultipleComponent } from "./../components/realizar-actividad-frame/opcion-multiple/opcion-multiple.component";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

export interface ActividadesdData {
  auth_key: string;
  data: [
    {
      id: number;
      nombre: string;
      descripcion: string;
    }
  ];
}

@Injectable({
  providedIn: "root",
})
export class ActividadesService {
  private lisRecursoEliminar = [];
  constructor(private http: HttpClient) {}
  getAll(id) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    postData.push({ auth_key: id });
    console.log("postData: ", postData);
    return this.http.post<ActividadesdData>(
      environment.urlActividades + "?opcion=1",
      JSON.stringify(postData)
    );
  }

  getAllActividadesCursos(id, curso_id) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    postData.push({ auth_key: id });
    postData.push({ curso_id: curso_id });
    console.log("postData: ", postData);
    return this.http.post(
      environment.urlActividades + "?opcion=2",
      JSON.stringify(postData)
    );
  }

  getHabilidades_Fecha(data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const valorB64 = btoa(JSON.stringify(data[0]));
    let response = this.http.get<any>(
      environment.urlCursos + "?opcion=1&code=" + valorB64
    );
    return response;
  }

  saveActividad(id, ejerciciosData: any) {
    console.log("🚀 ~ saveActividad ~ ejerciciosData:", ejerciciosData);
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    console.log("ejerciciosData: ", ejerciciosData);
    const formData = new FormData();
    ejerciciosData.nombreactividad;
    formData.append("auth_key", id);
    formData.append("Actividades[id_user]", ejerciciosData[0].id_user);
    formData.append(
      "Actividades[actividad_individual]",
      ejerciciosData[0].estudiantes.length > 0 ? "1" : "0"
    );
    formData.append("estudiantes[]", ejerciciosData[0].estudiantes);

    if (ejerciciosData[0].fecha) {
      formData.append("ActividadesFechahoraentrega[id_actividad]", "1");
      formData.append(
        "ActividadesFechahoraentrega[fecha_hora]",
        ejerciciosData[0].fecha
      );
    } else {
      formData.append("ActividadesFechahoraentrega[id_actividad]", "1");
    }

    if (ejerciciosData[0].fecha_fin) {
      formData.append("ActividadesFechahoraentrega[id_actividad]", "1");
      formData.append(
        "ActividadesFechahoraentrega[fecha_fin]",
        ejerciciosData[0].fecha_fin
      );
    } else {
      formData.append("ActividadesFechahoraentrega[id_actividad]", "1");
    }

    if (ejerciciosData[0].id_curso) {
      console.log("ejerciciosData.id_curso: ", ejerciciosData[0].id_curso);
    }
    formData.append("CursoActividades[id_curso]", ejerciciosData[0].id_curso);
    //
    formData.append(
      "Actividades[nombre_actividad]",
      ejerciciosData[0].nombre_actividad
    );

    ///ActividadesEvalHabilidades
    ejerciciosData[0].habilidades.forEach((elementHab, indexH) => {
      formData.append(
        "ActividadesActHabilidades[" + indexH + "][id_actividad]",
        elementHab.id
      );
      formData.append(
        "ActividadesActHabilidades[" + indexH + "][id_habilidad]",
        elementHab.index
      );
      formData.append(
        "ActividadesActHabilidades[" + indexH + "][nombre]",
        elementHab.valor
      );
    });

    // actividaes de opcion multiple
    let opcionMultiple = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 1
    );
    opcionMultiple.forEach((element, indexEjer) => {
      element.actividades.forEach((element2) => {
        formData.append(
          "ActividadOpmultiple[pregunta][" + indexEjer + "]",
          element2.opcionPregunta
        );
        formData.append(
          "ActividadOpmultiple[explicacion][" + indexEjer + "]",
          element2.opcionExplicacion
        );
        formData.append(
          "ActividadOpmultiple[tipo_recurso][" + indexEjer + "]",
          element2.type == 1 ? "img" : element2.type == 2 ? "video" : ""
        );
        if (element2.type == 1) {
          let file: File = element2.file;
          formData.append(
            "ActividadOpmultiple[recurso][" + indexEjer + "]",
            file,
            file.name + ""
          );
          formData.append(
            "ActividadOpmultiple[tipo_recurso][" + indexEjer + "]",
            element2.type == 1 ? "img" : element2.type == 2 ? "video" : ""
          );
        }
        if (element2.type == 2) {
          formData.append(
            "ActividadOpmultiple[recurso][" + indexEjer + "]",
            element2.url
          );
          formData.append(
            "ActividadOpmultiple[tipo_recurso][" + indexEjer + "]",
            element2.type == 1 ? "img" : element2.type == 2 ? "video" : ""
          );
        }
        element2.opciones.forEach((elementMulOP, indexOPM) => {
          formData.append(
            "ActividadOpmultipleOp[" +
              indexEjer +
              "][id_activi_mult][" +
              indexOPM +
              "]",
            elementMulOP.id
          );
          formData.append(
            "ActividadOpmultipleOp[" +
              indexEjer +
              "][opcion][" +
              indexOPM +
              "]",
            elementMulOP.respuesta
          );
          formData.append(
            "ActividadOpmultipleOp[" + indexEjer + "][vf][" + indexOPM + "]",
            elementMulOP.selected
          );
          formData.append(
            "ActividadOpmultipleOp[" +
              indexEjer +
              "][tipo_recurso][" +
              indexOPM +
              "]",
            elementMulOP.type == 1 ? "img" : elementMulOP.type == 2 ? "video" : ""
          );
          if (elementMulOP.type == 1) {
            let file: File = elementMulOP.file;
            //formData.append('ActividadOpmultipleOp['+count1+'][tipo_recurso]', elementMulOP.recurso.tipo);
            formData.append(
              "ActividadOpmultipleOp[recurso][" +
                indexEjer +
                "][" +
                indexOPM +
                "]",
              file,
              file.name + ""
            );
          }
          if (elementMulOP.type == 2) {
            //formData.append('ActividadOpmultipleOp['+count1+'][tipo_recurso]', elementMulOP.recurso.tipo);
            formData.append(
              "ActividadOpmultipleOp[" +
                indexEjer +
                "][recurso][" +
                indexOPM +
                "]",
              elementMulOP.url
            );
          }
        });
      });
    });

    // Actividades falso verdadero
    let falsoVerdadero = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 2
    );

    falsoVerdadero.forEach((element, indexEjer) => {
      element.actividades.forEach((element3) => {
        formData.append(
          "ActividadesVf[pregunta][" + indexEjer + "]",
          element3.pregunta
        );
        formData.append(
          "ActividadesVf[explicacion][" + indexEjer + "]",
          element3.explicacion
        );
        formData.append(
          "ActividadesVf[vf][" + indexEjer + "]",
          element3.vf === "v" ? "1" : "0"
        );
        formData.append(
          "ActividadesVf[id_tipo][" + indexEjer + "]",
          element3.id_tipo
        );
      });
    });

    /// Actividades Completaespacio
    let completaEspacio = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 3
    );
    completaEspacio.forEach((element, indexEjer) => {
      element.actividades.forEach((element4, index4, array4) => {
        formData.append(
          "ActividadesCompletaespacio[pregunta][" + indexEjer + "]",
          element4.valor
        );
        formData.append(
          "ActividadesCompletaespacio[explicacion][" + indexEjer + "]",
          element4.explicacion
        );
      });
    });
    let numRecurso = 0;
    //Actividades Ordenar o Secuencia
    let ordenar = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 4 || x.tipo == 9
    );
    ordenar.forEach((element, indexEjer) => {
      element.actividades.forEach((element4) => {
        formData.append(
          "ActividadesOrdenar[id_actividad][" + indexEjer + "]",
          "1"
        );
        formData.append(
          "ActividadesOrdenar[nombre][" + indexEjer + "]",
          element4.tipo == 1 ? "ordenar" : "secuencia"
        );
        formData.append(
          "ActividadesOrdenar[tipo][" + indexEjer + "]",
          element4.tipo
        );
        formData.append(
          "ActividadesOrdenar[explicacion][" + indexEjer + "]",
          element4.explicacion
        );
        element4.data.forEach((element4_1, index4_1) => {
          let file: File = element4_1.recurso.file;
          formData.append(
            "ActividadesOrdenarData[" +
              indexEjer +
              "][input][" +
              index4_1 +
              "]",
            element4_1.input
          );
          formData.append(
            "ActividadesOrdenarData[" + indexEjer + "][tipo][" + index4_1 + "]",
            element4_1.tipo
          );
          if (file) {
            formData.append(
              "ActividadesOrdenarData[recurso][" + numRecurso + "]",
              file,
              file.name + ""
            );
            formData.append(
              "ActividadesOrdenarData[" +
                indexEjer +
                "][recursook][" +
                index4_1 +
                "]",
              "1"
            );
          } else {
            formData.append(
              "ActividadesOrdenarData[" +
                indexEjer +
                "][recursook][" +
                index4_1 +
                "]",
              "0"
            );
          }
          numRecurso++;
        });
      });
    });

    // Actividades Memoria
    let indexCounter = 0;
    let memoria = ejerciciosData[0].ejercicios.filter((x) => x.tipo == 5);
    memoria.forEach((element, indexEjer) => {
      console.log("Memoria service", element.actividades);
      element.actividades.forEach((element5) => {
        formData.append(
          "ActividadesMemoria[id_actividad][" + indexEjer + "]",
          "1"
        );
        formData.append(
          "ActividadesMemoria[code_name][" + indexEjer + "]",
          "memoria"
        );
        // Deja solo un recurso por código no permite repetir el recurso por codigo
        const seenCodes = new Set<string>();
        const allItems: any[] = [];

        element5[0].data.forEach((group) => {
          group.x.forEach((item) => {
            if (seenCodes.has(item.code)) {
              // Si ya existe el code, limpiamos el recurso
              allItems.push({
                ...item,
                recursos: null,
                idy: group.y,
              });
            } else {
              seenCodes.add(item.code);
              allItems.push({ ...item, index: indexCounter++, idy: group.y });
            }
          });
        });
        console.log("🚀 ~ cleaned ~ cleaned:", allItems);
        allItems.forEach((element, indexRecurso) => {
          formData.append(
            "ActividadesMemoriaData[" +
              indexEjer +
              "][saveimg][" +
              indexRecurso +
              "]",
            element.recursos ? "1" : "0"
          );
          if (element.recursos) {
            let file: File = element.recursos.file;
            formData.append(
              "ActividadesMemoriaData[recurso][" + element.index + "]",
              file,
              file.name + ""
            );
          }
          formData.append(
            "ActividadesMemoriaData[" +
              indexEjer +
              "][id_memoria][" +
              indexRecurso +
              "]",
            "" + indexRecurso
          );
          formData.append(
            "ActividadesMemoriaData[" +
              indexEjer +
              "][id_y][" +
              indexRecurso +
              "]",
            element.idy
          );
          formData.append(
            "ActividadesMemoriaData[" +
              indexEjer +
              "][id_x][" +
              indexRecurso +
              "]",
            element.id
          );
          formData.append(
            "ActividadesMemoriaData[" +
              indexEjer +
              "][code][" +
              indexRecurso +
              "]",
            element.code
          );
        });
      });
    });

    // Actividades Sopaletras
    let sopaLetras = ejerciciosData[0].ejercicios.filter((x) => x.tipo == 6);
    sopaLetras.forEach((element, indexEjer) => {
      element.actividades.forEach((element6) => {
        formData.append(
          "ActividadesSopaletras[id_actividad][" + indexEjer + "]",
          "1"
        );
        formData.append(
          "ActividadesSopaletras[code_name][" + indexEjer + "]",
          "sopa_letras"
        );
        element6.valor.forEach((element6_1, index6_1) => {
          formData.append(
            "ActividadesSopaletrasData[" +
              indexEjer +
              "][id_sopa][" +
              index6_1 +
              "]",
            "" + index6_1
          );
          formData.append(
            "ActividadesSopaletrasData[" +
              indexEjer +
              "][palabra][" +
              index6_1 +
              "]",
            element6_1.palabra
          );
          formData.append(
            "ActividadesSopaletrasData[" +
              indexEjer +
              "][codigo][" +
              index6_1 +
              "]",
            element6_1.codigo
          );
          formData.append(
            "ActividadesSopaletrasData[" +
              indexEjer +
              "][tipo][" +
              index6_1 +
              "]",
            element6_1.tipo
          );
        });
      });
    });

    // Actividades Claseexplicacion

    let claseExplicacion = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 7
    );
    claseExplicacion.forEach((element, indexEjer) => {
      //ActividadesSopaletras
      element.actividades.forEach((element7) => {
        formData.append(
          "ActividadesClaseexpl[explicaciontema][" + indexEjer + "]",
          element7.explicaciontema
        );
        formData.append(
          "ActividadesClaseexpl[explicacion][" + indexEjer + "]",
          element7.explicaciontemaExpl
        );
        formData.append(
          "ActividadesClaseexpl[link_video][" + indexEjer + "]",
          element7.link_video ? element7.link_video : ""
        );
        formData.append(
          "ActividadesClaseexpl[recurso][" + indexEjer + "]",
          element7.image ? element7.image : ""
        );
        if (element7.image) {
          formData.append(
            "ActividadesClaseexpl[tipo_recurso][" + indexEjer + "]",
            "img"
          );
        }
      });
    });

    // Actividades Preguntaabierta
    let preguntaAbierta = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 8
    );
    preguntaAbierta.forEach((element, indexEjer) => {
      element.actividades.forEach((element8) => {
        formData.append(
          "ActividadesPreguntaabierta[pregunta][" + indexEjer + "]",
          element8.pregunta
        );
        formData.append(
          "ActividadesPreguntaabierta[explicacion][" + indexEjer + "]",
          ""
        );
        //
        if (element8.recurso.tipo == "img") {
          let file: File = element8.recurso.object;
          formData.append(
            "ActividadesPreguntaabierta[recurso][" + indexEjer + "]",
            file,
            file.name + ""
          );
        } else {
          if (element8.recurso.object) {
            formData.append(
              "ActividadesPreguntaabierta[recurso][" + indexEjer + "]",
              element8.recurso.object
            );
          }
        }
        formData.append(
          "ActividadesPreguntaabierta[tipo_recurso][" + indexEjer + "]",
          element8.recurso.tipo
        );
      });
    });

    var json = {};
    formData.forEach(function (value, key) {
      json[key] = value;
    });

    console.log("send Enviado JSON...", JSON.stringify(json));
    console.log("send Enviado...", formData); 
    return this.http.post(
      `${environment.urlActividades}?opcion=1`,
      formData,
      options
    );
  }

  makeRandom(lengthOfCode: number, possible: string = null) {
    let _possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    if (possible) {
      _possible = possible;
    }

    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += _possible.charAt(Math.floor(Math.random() * _possible.length));
    }
    return text;
  }
  dataURItoBlob(dataURI, mimeType) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: mimeType });
    return blob;
  }
  updateActividad(id, ejerciciosData: any, id_actividad: any) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    ejerciciosData.nombreactividad;
    formData.append("auth_key", id);
    formData.append("Actividades[id_user]", ejerciciosData[0].id_user);
    formData.append("id_actividad", id_actividad);

    if (ejerciciosData[0].fecha) {
      formData.append("ActividadesFechahoraentrega[id_actividad]", "1");
      formData.append(
        "ActividadesFechahoraentrega[fecha_hora]",
        ejerciciosData[0].fecha
      );
    }
    if (ejerciciosData[0].fecha_fin) {
      formData.append("ActividadesFechahoraentrega[id_actividad]", "1");
      formData.append(
        "ActividadesFechahoraentrega[fecha_fin]",
        ejerciciosData[0].fecha_fin
      );
    }
    if (ejerciciosData[0].id_curso) {
      console.log("ejerciciosData.id_curso: ", ejerciciosData[0].id_curso);
    }
    //
    formData.append(
      "Actividades[nombre_actividad]",
      ejerciciosData[0].nombre_actividad
    );

    ///ActividadesEvalHabilidades
    ejerciciosData[0].habilidades.forEach((elementHab, indexH) => {
      formData.append(
        "ActividadesActHabilidades[" + indexH + "][id_actividad]",
        elementHab.id
      );
      formData.append(
        "ActividadesActHabilidades[" + indexH + "][id_habilidad]",
        elementHab.index
      );
      formData.append(
        "ActividadesActHabilidades[" + indexH + "][nombre]",
        elementHab.valor
      );
    });

    // actividaes de opcion multiple
    let opcionMultiple = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 1
    );
    opcionMultiple.forEach((element, indexEjer) => {
      formData.append(
        "ActividadOpmultiple[id_actividad][" + indexEjer + "]",
        id_actividad
      );
      formData.append(
        "ActividadOpmultiple[id_ejercicio][" + indexEjer + "]",
        element.actividades.data.id
      );
      formData.append(
        "ActividadOpmultiple[pregunta][" + indexEjer + "]",
        element.actividades.data.pregunta
      );
      formData.append(
        "ActividadOpmultiple[explicacion][" + indexEjer + "]",
        element.actividades.data.explicacion
      );
      if (element.actividades.data.tipo_recurso === null) {
        this.lisRecursoEliminar.push(element.actividades.data.original);
        formData.append(
          "ActividadOpmultiple[tipo_recurso][" + indexEjer + "]",
          ""
        );
      } else {
        formData.append(
          "ActividadOpmultiple[tipo_recurso][" + indexEjer + "]",
          element.actividades.data.tipo_recurso
        );
      }
      if (element.actividades.data.tipo_recurso === "img") {
        if (element.actividades.data.file) {
          let _file = element.actividades.data.file;
          if (_file instanceof File) {
            let file: File = _file;
            formData.append(
              "ActividadOpmultiple[recurso][" + indexEjer + "]",
              file,
              file.name + ""
            );
            if (element.actividades.data.original) {
              this.lisRecursoEliminar.push(element.actividades.data.original);
            }
          }
        } else {
          formData.append(
            "ActividadOpmultiple[recurso][" + indexEjer + "]",
            element.actividades.data.original
          );
        }
      }
      if (element.actividades.data.tipo_recurso === "video") {
        formData.append(
          "ActividadOpmultiple[recurso][" + indexEjer + "]",
          element.actividades.data.recurso
        );
        this.lisRecursoEliminar.push(element.actividades.data.original);
      }

      element.actividades.dataOp.forEach((elementMulOP, indexOPM) => {
        formData.append(
          "ActividadOpmultipleOp[" +
            indexEjer +
            "][id_ejercicio][" +
            indexOPM +
            "]",
          elementMulOP.id
        );
        formData.append(
          "ActividadOpmultipleOp[" +
            indexEjer +
            "][id_activi_mult][" +
            indexOPM +
            "]",
          elementMulOP.id_activi_mult
        );
        formData.append(
          "ActividadOpmultipleOp[" + indexEjer + "][opcion][" + indexOPM + "]",
          elementMulOP.opcion
        );
        let opVf = "false";
        if (elementMulOP.vf == "1" || elementMulOP.vf == 1) {
          opVf = "true";
        }
        formData.append(
          "ActividadOpmultipleOp[" + indexEjer + "][vf][" + indexOPM + "]",
          opVf
        );
        if (elementMulOP.tipo_recurso === null) {
          this.lisRecursoEliminar.push(elementMulOP.original);
          formData.append(
            "ActividadOpmultipleOp[" +
              indexEjer +
              "][tipo_recurso][" +
              indexOPM +
              "]",
            ""
          );
        }

        if (elementMulOP.tipo_recurso === "img") {
          formData.append(
            "ActividadOpmultipleOp[" +
              indexEjer +
              "][tipo_recurso][" +
              indexOPM +
              "]",
            elementMulOP.tipo_recurso
          );
          if (elementMulOP.file) {
            let file: File = elementMulOP.file;
            if (file instanceof File) {
              formData.append(
                "ActividadOpmultipleOp[recurso][" + indexOPM + "]",
                file,
                file.name + ""
              );
              this.lisRecursoEliminar.push(elementMulOP.original);
            }
          } else {
            formData.append(
              "ActividadOpmultipleOp[" +
                indexEjer +
                "][recurso][" +
                indexOPM +
                "]",
              elementMulOP.original
            );
          }
        }
        if (elementMulOP.tipo_recurso == "video") {
          formData.append(
            `ActividadOpmultipleOp[${indexEjer}][tipo_recurso][${indexOPM}]`,
            elementMulOP.tipo_recurso
          );
          formData.append(
            `ActividadOpmultipleOp[${indexEjer}][recurso][${indexOPM}]`,
            elementMulOP.recurso
          );
          this.lisRecursoEliminar.push(elementMulOP.original);
        }
      });
    });
    // Actividades falso verdadero
    let falsoVerdadero = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 2
    );

    falsoVerdadero.forEach((element, indexEjer) => {
      formData.append(
        "ActividadesVf[id_actividad][" + indexEjer + "]",
        id_actividad
      );
      formData.append(
        "ActividadesVf[id_ejercicio][" + indexEjer + "]",
        element.actividades.data.id
      );
      formData.append(
        "ActividadesVf[pregunta][" + indexEjer + "]",
        element.actividades.data.pregunta
      );
      formData.append(
        "ActividadesVf[explicacion][" + indexEjer + "]",
        element.actividades.data.explicacion
      );
      let rVF = "0";
      if (
        element.actividades.data.vf == "v" ||
        element.actividades.data.vf == "1" ||
        element.actividades.data.vf == 1
      ) {
        rVF = "1";
      }
      formData.append("ActividadesVf[vf][" + indexEjer + "]", rVF);
    });

    /// Actividades Completaespacio
    let completaEspacio = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 3
    );

    completaEspacio.forEach((element, indexEjer) => {
      formData.append(
        "ActividadesCompletaespacio[id_actividad][" + indexEjer + "]",
        id_actividad
      );
      formData.append(
        "ActividadesCompletaespacio[id_ejercicio][" + indexEjer + "]",
        element.actividades.data.id
      );
      formData.append(
        "ActividadesCompletaespacio[pregunta][" + indexEjer + "]",
        element.actividades.data.pregunta
      );
      formData.append(
        "ActividadesCompletaespacio[explicacion][" + indexEjer + "]",
        element.actividades.data.explicacion
      );
    });

    //Actividades Ordenar o Secuencia
    let numRecurso = 0;
    let ordenar = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 4 || x.tipo == 9
    );
    ordenar.forEach((element, indexEjer) => {
      formData.append(
        "ActividadesOrdenar[id_actividad][" + indexEjer + "]",
        id_actividad
      );
      formData.append(
        "ActividadesOrdenar[id_ejercicio][" + indexEjer + "]",
        element.actividades.data.id
      );
      formData.append(
        "ActividadesOrdenar[nombre][" + indexEjer + "]",
        "ordenar"
      );
      formData.append(
        "ActividadesOrdenar[tipo][" + indexEjer + "]",
        element.actividades.data.tipo
      );
      formData.append(
        "ActividadesOrdenar[explicacion][" + indexEjer + "]",
        element.actividades.data.explicacion
      );
      element.actividades.dataOp.forEach((element4_1, index4_1) => {
        let file: File = element4_1.file;
        if (file instanceof File) {
          formData.append(
            "ActividadesOrdenarData[recurso][" + numRecurso + "]",
            file,
            file.name + ""
          );
          formData.append(
            "ActividadesOrdenarData[" +
              indexEjer +
              "][recursook][" +
              index4_1 +
              "]",
            "1"
          );
          if (element4_1.original) {
            this.lisRecursoEliminar.push(element4_1.original);
          }
          numRecurso++;
        } else {
          if (element4_1.recurso != null) {
            formData.append(
              "ActividadesOrdenarData[" +
                indexEjer +
                "][recursook][" +
                index4_1 +
                "]",
              "0"
            );
            formData.append(
              "ActividadesOrdenarData[" +
                indexEjer +
                "][recurso][" +
                index4_1 +
                "]",
              element4_1.original
            );
          } else {
            formData.append(
              "ActividadesOrdenarData[" +
                indexEjer +
                "][recursook][" +
                index4_1 +
                "]",
              "0"
            );
            if (element4_1.original) {
              this.lisRecursoEliminar.push(element4_1.original);
            }
          }
        }
        formData.append(
          "ActividadesOrdenarData[" + indexEjer + "][input][" + index4_1 + "]",
          element4_1.input
        );
        formData.append(
          "ActividadesOrdenarData[" + indexEjer + "][tipo][" + index4_1 + "]",
          element4_1.tipo
        );
        formData.append(
          "ActividadesOrdenarData[" +
            indexEjer +
            "][id_ejercicio][" +
            index4_1 +
            "]",
          element4_1.id
        );
      });
    });
    // Actividades Memoria
    let indexCounter = 0;
    let memoria = ejerciciosData[0].ejercicios.filter((x) => x.tipo == 5);
    memoria.forEach((element, indexEjer) => {
      formData.append(
        "ActividadesMemoria[id_actividad][" + indexEjer + "]",
        id_actividad
      );
      formData.append(
        "ActividadesMemoria[code_name][" + indexEjer + "]",
        "memoria"
      );
      if (element.actividades.delete) {
        element.actividades.delete.forEach((element5_1) => {
          if (element5_1) {
            this.lisRecursoEliminar.push(element5_1);
          }
        });
      }
      // Deja solo un recurso por código no permite repetir el recurso por codigo
      const seenCodes = new Set<string>();
      const allItems: any[] = [];

      element.actividades.dataOp.forEach((group) => {
        if (seenCodes.has(group.code)) {
          // Si ya existe el code, limpiamos el recurso
          allItems.push({
            ...group,
            file: null,
            recurso: null,
          });
        } else {
          seenCodes.add(group.code);
          allItems.push({ ...group, index: indexCounter++ });
        }
      });
      console.log("🚀 ~ cleaned ~ cleaned:", allItems);
      allItems.forEach((element5_1, index5_1) => {
        formData.append(
          "ActividadesMemoriaData[" +
            indexEjer +
            "][id_ejercicio][" +
            index5_1 +
            "]",
          element5_1.id
        );
        let file: any = element5_1.file;
        if (file instanceof File) {
          formData.append(
            "ActividadesMemoriaData[recurso][" + index5_1 + "]",
            file,
            file.name + ""
          );
          formData.append(
            "ActividadesMemoriaData[" +
              indexEjer +
              "][saveimg][" +
              index5_1 +
              "]",
            "1"
          );
        } else {
          if (element5_1.original) {
            formData.append(
              "ActividadesMemoriaData[" +
                indexEjer +
                "][recurso][" +
                index5_1 +
                "]",
              element5_1.original
            );
            formData.append(
              "ActividadesMemoriaData[" +
                indexEjer +
                "][saveimg][" +
                index5_1 +
                "]",
              "0"
            );
          }
        }

        formData.append(
          "ActividadesMemoriaData[" +
            indexEjer +
            "][id_memoria][" +
            index5_1 +
            "]",
          element5_1.id_memoria
        );
        formData.append(
          "ActividadesMemoriaData[" + indexEjer + "][id_y][" + index5_1 + "]",
          element5_1.id_y
        );
        formData.append(
          "ActividadesMemoriaData[" + indexEjer + "][id_x][" + index5_1 + "]",
          element5_1.id_x
        );
        formData.append(
          "ActividadesMemoriaData[" + indexEjer + "][code][" + index5_1 + "]",
          element5_1.code
        );
      });
    });

    // Actividades Sopaletras
    let sopaLetras = ejerciciosData[0].ejercicios.filter((x) => x.tipo == 6);
    sopaLetras.forEach((element, indexEjer) => {
      formData.append(
        "ActividadesSopaletras[id_actividad][" + indexEjer + "]",
        "1"
      );
      formData.append(
        "ActividadesSopaletras[code_name][" + indexEjer + "]",
        "sopa_letras"
      );
      element.actividades.dataOp.forEach((element6_1, index6_1) => {
        formData.append(
          "ActividadesSopaletrasData[" +
            indexEjer +
            "][id_sopa][" +
            index6_1 +
            "]",
          "1"
        );
        formData.append(
          "ActividadesSopaletrasData[" +
            indexEjer +
            "][palabra][" +
            index6_1 +
            "]",
          element6_1.palabra
        );
        formData.append(
          "ActividadesSopaletrasData[" +
            indexEjer +
            "][codigo][" +
            index6_1 +
            "]",
          element6_1.codigo
        );
        formData.append(
          "ActividadesSopaletrasData[" +
            indexEjer +
            "][tipo][" +
            index6_1 +
            "]",
          element6_1.tipo
        );
      });
    });

    // Actividades Claseexplicacion

    let claseExplicacion = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 7
    );
    console.log(
      "🚀 ~ ActividadesService ~ updateActividad ~ claseExplicacion:",
      claseExplicacion
    );

    claseExplicacion.forEach((element, indexEjer) => {
      formData.append(
        "ActividadesClaseexpl[id_actividad][" + indexEjer + "]",
        "1"
      );
      formData.append(
        "ActividadesClaseexpl[explicaciontema][" + indexEjer + "]",
        element.actividades.data.explicaciontema
      );
      formData.append(
        "ActividadesClaseexpl[explicacion][" + indexEjer + "]",
        element.actividades.data.explicacion
      );
      if (
        element.actividades.data.link_video &&
        element.actividades.data.link_video != "null"
      ) {
        formData.append(
          "ActividadesClaseexpl[link_video][" + indexEjer + "]",
          element.actividades.data.link_video
        );
        if (element.actividades.data.original) {
          this.lisRecursoEliminar.push(element.actividades.data.original);
        }
      } else if (element.actividades.data.file) {
        formData.append(
          "ActividadesClaseexpl[recurso][" + indexEjer + "]",
          element.actividades.data.file
        );
        formData.append(
          "ActividadesClaseexpl[tipo_recurso][" + indexEjer + "]",
          "img"
        );
        if (element.actividades.data.original) {
          this.lisRecursoEliminar.push(element.actividades.data.original);
        }
      } else {
        if (element.actividades.data.original) {
          formData.append(
            "ActividadesClaseexpl[recurso][" + indexEjer + "]",
            element.actividades.data.original
          );
          formData.append(
            "ActividadesClaseexpl[tipo_recurso][" + indexEjer + "]",
            "img"
          );
        }
      }
    });

    // Actividades Preguntaabierta
    let preguntaAbierta = ejerciciosData[0].ejercicios.filter(
      (x) => x.tipo == 8
    );

    preguntaAbierta.forEach((element, indexEjer) => {
      formData.append(
        "ActividadesPreguntaabierta[id_ejercicio][" + indexEjer + "]",
        element.actividades.data.id
      );
      formData.append(
        "ActividadesPreguntaabierta[id_actividad][" + indexEjer + "]",
        element.actividades.data.id_actividad
      );
      formData.append(
        "ActividadesPreguntaabierta[tipo_recurso][" + indexEjer + "]",
        element.actividades.data.tipo_recurso
      );
      formData.append(
        "ActividadesPreguntaabierta[pregunta][" + indexEjer + "]",
        element.actividades.data.pregunta
      );
      formData.append(
        "ActividadesPreguntaabierta[explicacion][" + indexEjer + "]",
        ""
      );

      if (element.actividades.data.tipo_recurso == "img") {
        /***********File */
        let _file: any = element.actividades.data.file;
        if (_file instanceof File) {
          formData.append(
            "ActividadesPreguntaabierta[recurso][" + indexEjer + "]",
            _file,
            _file.name + ""
          );
          //this.lisRecursoEliminar.push(element.actividades.data.original);
        } else {
          formData.append(
            "ActividadesPreguntaabierta[recurso][" + indexEjer + "]",
            element.actividades.data.original
          );
        }
      } else {
        formData.append(
          "ActividadesPreguntaabierta[recurso][" + indexEjer + "]",
          element.actividades.data.recurso
        );
        //this.lisRecursoEliminar.push(element.actividades.data.original);
      }
    });

    //elimnar recursos
    this.lisRecursoEliminar.forEach((element, index, array) => {
      console.log(
        "🚀 ~ this.lisRecursoEliminar.forEach ~ this.lisRecursoEliminar.:",
        this.lisRecursoEliminar
      );
      formData.append("eliminar[" + index + "]", element);
    });
    //console.log('formData: ',formData);
    console.log("send...");
    return this.http.post(
      `${environment.urlActividades}?opcion=2`,
      formData,
      options
    );
    /*formData.append('file', blobData, `myimage.${ext}`);
    formData.append('name', name);*/
  }

  actividadCursoCalificable(id, auth_key, id_actividad, id_curso) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("id_actividad", id_actividad);
    formData.append("id_curso", id_curso);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=53",
      formData,
      options
    );
  }

  base64ToFile(base64String, fileName, mimeType) {
    // Decodifica la cadena base64
    const byteCharacters = atob(base64String);

    // Convierte los caracteres a bytes
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Crea un Blob con los bytes decodificados
    const blob = new Blob([byteArray], { type: mimeType });

    // Crea un archivo a partir del Blob
    const file = new File([blob], fileName, { type: mimeType });

    return file;
  }

  setActividadDisponible(id, auth_key, id_actividad, id_curso) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("Cursos[id_user]", id);
    formData.append("id_actividad", id_actividad);
    formData.append("id_curso", id_curso);
    return this.http.post<any>(
      environment.urlCursos + "?opcion=57",
      formData,
      options
    );
  }
}
